import { render, staticRenderFns } from "./vehicleDispatch.vue?vue&type=template&id=4c38b412&"
import script from "./vehicleDispatch.vue?vue&type=script&lang=js&"
export * from "./vehicleDispatch.vue?vue&type=script&lang=js&"
import style0 from "./vehicleDispatch.vue?vue&type=style&index=0&id=4c38b412&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports